import React from 'react';
import { Link } from 'react-router-dom';

// RelatedContent block — internal cross-links (e.g. the service mesh). Presentation only. Preserves
// the WP-3.4 "Autres prestations" markup + data-testids so the internal-link topology is unchanged.
export default function RelatedContent({ heading = 'Autres prestations', links }) {
  return (
    <section className="mt-6 border-t border-neutral-100 py-12" data-testid="related-services">
      <h2 className="mb-6 font-heading text-xl md:text-2xl font-bold text-black tracking-tight">{heading}</h2>
      <ul className="grid gap-3 sm:grid-cols-2">
        {links.map((l) => (
          <li key={l.to}>
            <Link
              to={l.to}
              className="flex items-center justify-between rounded-xl border border-neutral-200 bg-white px-5 py-4 text-neutral-800 transition hover:border-neutral-400 hover:shadow-sm"
              data-testid={`related-service-${l.to.split('/').pop()}`}
            >
              <span className="font-medium">{l.label}</span>
              <span aria-hidden="true" className="text-neutral-400">&rarr;</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
